<script>
  export let href = '#',
    bold = false,
    noUnderline = false,
    purple = false,
    pink = false,
    orange = false,
    black = false,
    white = false;
</script>

<style lang="scss">
  @import '../../styles/settings/core';
  @import '../../styles/settings/colors';

  .bold {
    font-weight: 600;
  }

  .noUnderline {
    text-decoration: none;
  }

  .link {
    color: inherit;
  }

  .purple {
    color: $purple-50;
  }

  .orange {
    color: $orange-50;
  }

  .pink {
    color: $pink-50;
  }

  .white {
    color: $white;
  }

  .black {
    color: $black;
  }
</style>

<a
  class="link"
  class:purple
  class:pink
  class:black
  class:white
  class:orange
  class:bold
  class:noUnderline
  {href}
>
  <slot />
</a>
